import dayjs from 'dayjs';

import breadcrumbFor from './breadcrumbFor';

const generateBreadcrumbs = (menu, { entity }, otherParams) => {
  // No top level means the user has nothing to navigate (no classes, no report
  // access). Return null rather than [null]: callers map over the result.
  const _default = menu?.topLevel ? [menu.topLevel] : null;
  if(_default && entity){
    const generateEntityBreadcrumbs = (entity, upto) => {
      if(entity){
        const item = breadcrumbFor(entity);
        switch(entity.__typename){
          case 'Class': return [...generateEntityBreadcrumbs(entity.school, upto), item];
          case 'School': return [...generateEntityBreadcrumbs(entity.district, upto), item];
          case 'District': return [...generateEntityBreadcrumbs(entity[upto]), item];
          case 'State': return [item];
          case 'ProgramGroup': return [item];
        }
      }
      return [];
    }
    const mergeBreadcrumbs = (menu, entityBreadcrumbs) => {
      const index = ['Programs', 'States'].includes(menu.at(-1).type) ? (
        entityBreadcrumbs.findIndex(({ type }) => `${type}s` === menu.at(-1).type)
      ) : (
        ((r) => r < 0 ? r : r + 1)(entityBreadcrumbs.findIndex(({ id, type }) => menu.at(-1).type === type && menu.at(-1).id === id))
      );
      const breadcrumbs = index < 0 ? null : menu.concat(entityBreadcrumbs.slice(index));

      const options = [breadcrumbs, ...menu.at(-1).submenus?.map(item => mergeBreadcrumbs([...menu, item], entityBreadcrumbs)) ?? []].filter(Boolean);
      return options.length <= 1 ? options[0] : options.reduce((current, next) => current.length < next.length ? next : current);
    };
    const checkEntity = entity.__typename !== 'User' ? entity : (
      ((
        entity.enrollments?.find(e => e.class.type && e.class.id === otherParams.classId)
      ) ?? (
        entity.enrollments?.filter(e => ['HOMEROOM', null].includes(e.class.type)).find(e => dayjs().isBetween(e.from, e.to, 'day', '[]'))
      ))?.class
    );
    const a = mergeBreadcrumbs(_default, generateEntityBreadcrumbs(checkEntity, 'programGroup'));
    const b = mergeBreadcrumbs(_default, generateEntityBreadcrumbs(checkEntity, 'state'));
    if(a){
      if(b){ return a.length < b.length ? a : b; }
      return a;
    }
    return b ?? _default;
  }
  return _default;
}

export default generateBreadcrumbs;
